module.exports = __webpack_public_path__ + "static/media/session_expired.55f789f0.svg";